module.exports = __webpack_public_path__ + "img/bg_math_01.d1417605.jpg";